import * as _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';

import PlusIcon from '@material-ui/icons/PlaylistAdd';

import HDrawer from '../../../common/HDrawer';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import CircuitCreate from '../CircuitCreate';

import Console from '../../../../lib/debug';
import { closeVideoPlayer } from '../../../common/VideoPlayerUtil';

export class CircuitCreateDrawerClass extends React.Component {
    getTagIds = circuit => {
        return _.pluck(circuit.tags, 'id');
    };

    handleSave = circuit => {
        const tagIds = this.getTagIds(circuit);
        DesignerState.createCircuit(circuit, tagIds, this.props.block);
        closeVideoPlayer();
    };

    handleClose = () => {
        DesignerState.toggleCircuitDialog(this.props.block, false);
        closeVideoPlayer();
    };

    render() {
        Console.render('CircuitCreateDrawer');
        return (
            <HDrawer
                open={this.props.newCircuitDialog}
                onClose={this.handleClose}
                title="Save Circuit to Library"
                subTitle=""
                icon={<PlusIcon />}
            >
                <CircuitCreate
                    combo={this.props.block}
                    block={this.props.block}
                    isSidenav={true}
                    exerciseTags={this.props.exerciseTags}
                    exerciseRef={this.props.exerciseRef}
                    exerciseTree={this.props.exerciseTree}
                    exerciseBenchmarkRef={this.props.exerciseBenchmarkRef}
                    onClose={this.handleClose}
                    onSave={this.handleSave}
                />
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        block: state.calendar.uiTree.block,
        exercise: state.calendar.uiTree.exercise,
        exerciseBenchmarkRef: state.library.exerciseBenchmarkRef,
        exerciseRef: state.library.exerciseRef,
        exerciseTree: state.calendar.exerciseTree,
        exerciseTags: state.calendar.uiTree.exerciseTags,
        newCircuitDialog: !!state.calendar.uiTree.newCircuitDialog,
        ...ownProps
    };
};

export default connect(mapStateToProps)(CircuitCreateDrawerClass);
